import { DATE_FORMAT_2 } from "../constants/constant";
import { formatDate, apiGETRequest, apiRequest } from "../utility/Utility";

//Fetching User Details for an emailId
export const getAllPWS = async (emailId) => {
  try {
    const response = await apiGETRequest({
      endpoint: "/get-all-pws",
      payload: { email: emailId },
    });

    return {
      status: 0,
      title: "Fetched PWSs info",
      message: "Success",
      data: response.data,
    };
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message: "Error occured while fetching pws details: " + error.message,
    };
  }
};

export const getContactsReport = async () => {
  try {
    const response = await apiGETRequest({
      endpoint: "/api/admin-contact-report",
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Fetching contacts report",
      message: "Success",
      data: response.data,
    };
  } catch (error) {
    /*console.error(
            "Exception occured while fetching pws details: ",
            error.message
        );*/
    return {
      status: -1,
      title: "Error occured",
      message: "Error occured while fetching report: " + error.message,
    };
  }
};

//Fetching User Details for an emailId
export const getWellInfoReport = async () => {
  try {
    const response = await apiGETRequest({
      endpoint: "/api/admin-wellsinfo-report",
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Fetching contacts report",
      message: "Success",
      data: response.data,
    };
  } catch (error) {
    /*console.error(
            "Exception occured while fetching pws details: ",
            error.message
        );*/
    return {
      status: -1,
      title: "Error occured",
      message: "Error occured while fetching report: " + error.message,
    };
  }
};

export const getContactRoles = async () => {
  try {
    const response = await apiGETRequest({
      endpoint: "/api/admin-contact-roles",
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Success",
      message: "Fetched DE Contacts Information",
      data: response.data,
    };
  } catch (error) {
    console.error(
      "Exception occurred while fetching DE contacts information: ",
      error.message,
    );
    return {
      status: -1,
      title: "Error occurred",
      message:
        "Error occurred while fetching DE contacts information: " +
        error.message,
    };
  }
};

export const getEDDReport = async () => {
  try {
    const response = await apiGETRequest({
      endpoint: "/api/admin-edd-report",
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Fetching edd report",
      message: "Success",
      data: response.data,
    };
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message: "Error occured while edd report: " + error.message,
    };
  }
};

export const getWellsSWBReport = async (report_type) => {
  try {
    let params = {
      report_type: report_type,
    };
    const response = await apiGETRequest({
      endpoint: "/reports",
      payload: params,
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Fetching SWB final wells report",
      message: "Success",
      data: response.data,
    };
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message: "Error occured while SWB final wells report: " + error.message,
    };
  }
};

export const getUserPreferredLang = async () => {
  try {
    const response = await apiGETRequest({
      endpoint: "/api/user-preferred-lang",
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Fetching user preferred language report",
      message: "Success",
      data: response.data,
    };
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message:
        "Error occured while user preferred language report: " + error.message,
    };
  }
};

export const getWellSamplingStatus = async () => {
  try {
    const response = await apiGETRequest({
      endpoint: "/api/getWellsSamplingStatus",
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Fetching visits confirmed status report",
      message: "Success",
      data: response.data,
    };
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message:
        "Error occured while fetching visits confirmed status report: " +
        error.message,
    };
  }
};

export const PWSByDistrictOffice = {
  getRegulatingAgencies: {
    key: ["regulatingAgencies"],
    endpoint: "/fetchAllRegulatingAgencies",
  },
  getPWSByRegulatingAgency: {
    endpoint: "/api/dashboardData",
  },
};

export const getSWBContacts = {
  getSWBVetted: {
    key: ["SWBVetted"],
    endpoint: "/swb-wells-contacts",
  },
  getSWBPWS: {
    key: ["SWBPWS"],
    endpoint: "/swb-wells-contacts",
  },
  getSWBWells: {
    key: ["SWBWells"],
    endpoint: "/swb-wells-contacts",
  },
  getClaimedWells: {
    key: ["AckWellsContacts"],
    endpoint: "/api/admin-acknowledged-wells",
  },
  getDistrictEngineers: {
    key: ["DistrictEngContacts"],
    endpoint: "/api/admin-de-contacts",
  },
};

// * React Query API Endpoints

export const WaterSystemContacts = {
  getWaterSystemContacts: {
    key: ["WaterSystemContacts"],
    endpoint: "/getPWSContactDetails",
  },
};

export const SchedulingGoals = {
  getMonthlyVisits: {
    key: ["MonthlyVisits"],
    endpoint: "/visits/schedule-goals",
  },
  getWeeklyVisits: {
    key: ["WeeklyVisits"],
    endpoint: "/visits/schedule-goals",
  },
  getDailyVisits: {
    key: ["DailyVisits"],
    endpoint: "/visits/schedule-goals",
  },
};

export const getBottleOrders = async (tabId, selectedDay) => {
  const response = await apiGETRequest({
    endpoint: `/api/fetchLabShipmentDetails`,
    payload: { selectedDay, tabID: tabId },
    returnRaw: true,
  });
  return response.data;
};

export const getSamplerEmails = async () => {
  const response = await apiGETRequest({
    endpoint: "/api/fetchAllSamplers",
    returnRaw: true,
  });
  return response.data;
};

export const printAllCOCs = async (sampler_email, visit_date) => {
  try {
    const response = await apiGETRequest({
      endpoint: "/api/print-all-cocs",
      payload: {
        sampler_email,
        visit_date,
      },
      config: {
        responseType: "blob", // Expect a file for download
      },
      returnRaw: true,
    });

    // Create a Blob from the response data and trigger the download
    const blob = new Blob([response.data], { type: "application/zip" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${sampler_email}-all-cocs-${formatDate(
      visit_date,
      DATE_FORMAT_2,
    )}.zip`;
    document.body.appendChild(link);
    link.click();

    // Clean up the created elements and URL object
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return {
      status: 0,
      title: "Success",
      message: "All COCs have been downloaded successfully!",
    };
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const errorText = await error.response.data.text();
      const errorJson = JSON.parse(errorText);

      throw new Error(
        errorJson.detail || errorJson.message || "An unknown error occurred.",
      );
    }
    throw error;
  }
};

export const fetchVisitsBySampler = async (sampler) => {
  const response = await apiGETRequest({
    endpoint: "/api/getVisitsBySampler",
    payload: { sampler },
    returnRaw: true,
  });
  return response.data;
};

export const updateShipmentInfo = async ({
  shipTrackNum,
  samplesShippedBy,
  shipDate,
  new_ps_code,
  user_email,
}) => {
  const response = await apiRequest({
    endpoint: "/api/updateSampleShipInfo",
    payload: {
      shipTrackNum,
      samplesShippedBy,
      shipDate,
      new_ps_code,
      user_email,
    },
    returnRaw: true,
  });
  return response.data;
};

export const updateVisitConfirmation = async ({ data, visit_id, well_id }) => {
  try {
    const response = await apiRequest({
      endpoint: "/visits/update-visit",
      payload: {
        data,
        visit_id,
        well_id,
      },
      returnRaw: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const dataImport = async (formData) => {
  try {
    const response = await apiRequest({
      endpoint: "/import",
      payload: formData,
      returnRaw: true,
    });
    if (response.status === 0) {
      throw new Error(response);
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};
